module.exports = __webpack_public_path__ + "img/focus_grip.6f6df7df.svg";